export default __webpack_public_path__ + "5aef0fcd82b63563bd92dbf34736f8d9.jpg";